/* Clean + Kind, SPF Landing — interactive behavior.
   Bound to every .spf-l[data-section-id] root, so multiple instances on a
   page each get their own listeners. */
(function () {
  function init(root) {
    if (!root || root.dataset.spfInit === '1') return;
    root.dataset.spfInit = '1';

    /* Reveal section once JS + CSS are ready — prevents FOUC flash */
    root.classList.add('spf-ready');

    /* Scroll progress hairline */
    var bar = root.querySelector('.spf-progress');
    function progress() {
      var h = document.documentElement;
      var pct = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
      if (bar) bar.style.setProperty('--p', pct + '%');
    }
    window.addEventListener('scroll', progress, { passive: true });
    progress();

    /* FAQ accordion */
    root.querySelectorAll('.spf-faq__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    /* Ingredient chip click toggles popover (touch parity) */
    root.querySelectorAll('.spf-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var open = chip.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('.spf-chip[aria-expanded="true"]').forEach(function (c) {
          if (c !== chip) c.setAttribute('aria-expanded', 'false');
        });
        chip.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    /* Sticky shop chip — show after hero scrolls past */
    var chip = root.querySelector('[data-sticky]');
    if (chip) {
      var hero = root.querySelector('.spf-hero');
      function toggleSticky() {
        if (!hero) return;
        var heroBottom = hero.getBoundingClientRect().bottom;
        if (heroBottom < 0) chip.classList.add('is-visible');
        else chip.classList.remove('is-visible');
      }
      window.addEventListener('scroll', toggleSticky, { passive: true });
      toggleSticky();
    }

    /* Sticky add-to-cart bar — show after hero scrolls past */
    var stickyBar = root.querySelector('[data-sticky-bar]');
    if (stickyBar) {
      var heroBar = root.querySelector('.spf-hero');
      function toggleStickyBar() {
        if (!heroBar) return;
        var heroBottom = heroBar.getBoundingClientRect().bottom;
        if (heroBottom < 0) stickyBar.classList.add('is-visible');
        else stickyBar.classList.remove('is-visible');
      }
      window.addEventListener('scroll', toggleStickyBar, { passive: true });
      toggleStickyBar();
    }

    /* UGC video — autoplay muted to paint first frame on mobile (iOS Safari
       ignores preload and poster until user interacts). We autoplay then
       immediately pause once the first frame is visible. Controls are
       restored so the user can still play/pause manually. */
    root.querySelectorAll('[data-ugc-video]').forEach(function (vid) {
      function paintFirstFrame() {
        vid.currentTime = 0.001;
        var playPromise = vid.play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            /* First frame painted — pause immediately */
            vid.pause();
            vid.currentTime = 0;
          }).catch(function () {
            /* Autoplay blocked — seek to first frame as fallback */
            vid.currentTime = 0.001;
          });
        }
      }

      if (vid.readyState >= 2) {
        paintFirstFrame();
      } else {
        vid.addEventListener('loadeddata', paintFirstFrame, { once: true });
        /* Timeout fallback — if loadeddata never fires (slow connection) */
        setTimeout(function () {
          if (vid.readyState < 2) {
            vid.load();
            vid.addEventListener('loadeddata', paintFirstFrame, { once: true });
          }
        }, 2000);
      }

      /* On user play — let it loop normally */
      vid.addEventListener('play', function () {
        vid.loop = true;
      });
    });
  }

  function bootAll() {
    document.querySelectorAll('.spf-l[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Re-bind when Shopify theme editor inserts a section */
  document.addEventListener('shopify:section:load', bootAll);
})();

